import {combineReducers} from 'redux'
import {routerReducer} from 'react-router-redux'
import {config} from './config'
import {colors, backgroundColors} from './colors'
import {navigation} from './navigation'
import {contactUs} from './pages/contact-us'
import {createAccount} from './pages/create-account'
import {resetPassword} from './pages/reset-password'
import {subscribe} from './pages/subscribe'
import {underMaintenance} from './pages/under-maintenance'
import {unlockAccount} from './pages/unlock-account'
import {accountSettings} from './pages/account-settings'
import {emailPreferences} from './pages/email-preferences'
import {securitySettings} from './pages/security-settings'
import {reducer as notificationsReducer} from 'reapop'

import {common} from './common'
import {dashboardPage} from './pages/panel-admin/dashboard-page'
import {talentExportPage} from './pages/panel-admin/talent-export-page'
import {articleEditForm} from './pages/panel-admin/article-edit-form'
import {userEditForm} from './pages/panel-admin/user-edit-form'
import {productionPage} from './pages/panel-admin/production-page'
import {mapChartsPage} from './pages/panel-admin/map-charts-page'
import {productionSearch} from './pages/panel-admin/production-search'
import {productionActivate} from './pages/panel-admin/production-activate'
import {skillVendorPage} from './pages/panel-admin/skillvendor-page'
import {skillVendorEdit} from './pages/panel-admin/skillvendor-edit'
import {skillVendorSearch} from './pages/panel-admin/skillvendor-search'
import {vacancyPage} from './pages/panel-admin/vacancy-page'
import {vacancyActivate} from './pages/panel-admin/vacancy-activate'
import {vacancyCandidateSearch} from './pages/panel-admin/vacancy-candidate-search'
import {vacancyCriteriaDirector} from './pages/panel-admin/vacancy-criteria-director'
import {vacancyCriteriaTranslator} from './pages/panel-admin/vacancy-criteria-translator'
import {vacancyCriteriaVoiceActor} from './pages/panel-admin/vacancy-criteria-voiceactor'
import {vacancyCriteriaSinger} from './pages/panel-admin/vacancy-criteria-singer'
import {vacancyCriteriaAdaptor} from './pages/panel-admin/vacancy-criteria-adaptor'
import {vacancyCriteriaLyricist} from './pages/panel-admin/vacancy-criteria-lyricist'
import {vacancyCriteriaEditor} from './pages/panel-admin/vacancy-criteria-editor'
import {vacancyCriteriaSoundEngineer} from './pages/panel-admin/vacancy-criteria-soundengineer'
import {vacancyCriteriaBooker} from './pages/panel-admin/vacancy-criteria-booker'
import {voiceTestPage} from './pages/panel-admin/voice-test-page'
import {voiceTestActivate} from './pages/panel-admin/voice-test-activate'
import {voiceTestCandidateSearch} from './pages/panel-admin/voice-test-candidate-search'
import {voiceTestCriteriaDirector} from './pages/panel-admin/voice-test-criteria-director'
import {voiceTestCriteriaTranslator} from './pages/panel-admin/voice-test-criteria-translator'
import {voiceTestCriteriaVoiceActor} from './pages/panel-admin/voice-test-criteria-voiceactor'
import {voiceTestCriteriaSinger} from './pages/panel-admin/voice-test-criteria-singer'
import {voiceTestCriteriaAdaptor} from './pages/panel-admin/voice-test-criteria-adaptor'
import {voiceTestCriteriaLyricist} from './pages/panel-admin/voice-test-criteria-lyricist'
import {voiceTestCriteriaEditor} from './pages/panel-admin/voice-test-criteria-editor'
import { voiceTestCriteriaSoundEngineer } from './pages/panel-admin/voice-test-criteria-soundengineer'
import { voiceTestCriteriaBooker } from './pages/panel-admin/voice-test-criteria-booker'
import { voiceTestAndVacancyCriteria } from './pages/panel-admin/voice-test-and-vacancy-criteria'
import {clientRequestSearch} from './pages/panel-admin/client-request-search'
import {clientAccountSearch} from './pages/panel-admin/client-account-search'
import {clientRequestActivate} from './pages/panel-admin/client-request-activate'
import {profileActor} from './pages/panel-admin/profile-actor'

const rootReducer = combineReducers({
  config,
  colors,
  backgroundColors,
  navigation,
  contactUs,
  createAccount,
  resetPassword,
  subscribe,
  underMaintenance,
  unlockAccount,
  accountSettings,
  emailPreferences,
  securitySettings,
  router: routerReducer,
  notifications: notificationsReducer(),

  common,
  dashboardPage,
  talentExportPage,
  articleEditForm,
  userEditForm,
  productionPage,
  mapChartsPage,
  productionSearch,
  productionActivate,
  skillVendorPage,
  skillVendorEdit,
  skillVendorSearch,
  vacancyPage,
  vacancyActivate,
  vacancyCandidateSearch,
  vacancyCriteriaDirector,
  vacancyCriteriaTranslator,
  vacancyCriteriaVoiceActor,
  vacancyCriteriaSinger,
  vacancyCriteriaAdaptor,
  vacancyCriteriaLyricist,
  vacancyCriteriaEditor,
  vacancyCriteriaSoundEngineer,
  vacancyCriteriaBooker,
  voiceTestPage,
  voiceTestActivate,
  voiceTestCandidateSearch,
  voiceTestCriteriaDirector,
  voiceTestCriteriaTranslator,
  voiceTestCriteriaVoiceActor,
  voiceTestCriteriaSinger,
  voiceTestCriteriaAdaptor,
  voiceTestCriteriaLyricist,
  voiceTestCriteriaEditor,
  voiceTestCriteriaSoundEngineer,
  voiceTestCriteriaBooker,
  voiceTestAndVacancyCriteria,
  clientRequestSearch,
  clientAccountSearch,
  clientRequestActivate,
  profileActor
})
export default rootReducer
